import { render } from "./ImageCapture.vue?vue&type=template&id=1f00e17a&scoped=true"
import script from "./ImageCapture.vue?vue&type=script&lang=js"
export * from "./ImageCapture.vue?vue&type=script&lang=js"

import "./ImageCapture.vue?vue&type=style&index=0&id=1f00e17a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f00e17a"]])

export default __exports__